import { forwardRef, type HTMLAttributes } from 'react';

import { twcn } from '@web/ui/core/utils';

/*
 * Kbd — inline keyboard hint.
 *
 * Examples:
 *   <Kbd>⌘K</Kbd>
 *   <span>Press <Kbd>⌘</Kbd><Kbd>K</Kbd> to search</span>
 */
export const Kbd = forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(function Kbd(
  { className, ...props },
  ref,
) {
  return (
    <kbd
      ref={ref}
      className={twcn(
        'inline-flex h-4.5 items-center rounded-sm border border-border border-b-2 bg-card px-1.5 font-mono text-tiny font-medium text-muted-foreground',
        className,
      )}
      {...props}
    />
  );
});
